<template>
  <q-page>
    <PageBreadcrumbs :items="[{ label: 'Search' }]" />
    <div class="bg-dark q-px-md q-pb-md">
      <h1 class="text-h3 text-weight-medium no-margin">
        {{ title }}
      </h1>
    </div>
    <div class="q-pa-md">
      <CatalogCollection
        name="Search Results"
        :data-key="`search_${search ?? 'all'}_products`"
      />
    </div>
  </q-page>
</template>

<script lang="ts" setup>
defineOgImage();

useSeoMeta({
  title: () =>
    'Find Guns, Parts & Accessories Online',
  description: () =>
    'Use our search to quickly find firearms, gear, and accessories. Browse guns, parts, storage, and more from top brands, all in one place.',
});

useSchemaOrg([
  defineWebPage({
    '@type': ['CollectionPage', 'SearchResultsPage'],
  }),
]);

const { filters, search } = useFilters();

const title = computed(() => {
  const parts = ['All'];

  if (filters.condition.active.value) {
    parts.push(filters.condition.data.value!.join('/'));
  }

  let _: unknown = filters.firearms.active.value
    ? parts.push(filters.firearms.data.value ? ' Firearms' : ' Non-Firearms')
    : parts.push('Products');

  _ = !filters.sale.active.value || parts.push(filters.sale.data.value ? 'On Sale' : 'Not On Sale');

  _ = search.value === null || parts.push(`Matching "${search.value}"`);

  switch (filters.availability.data.value) {
    case 'instock':
      parts.push('In Stock');
      break;
    case '103':
      parts.push('Available In KYGUNCO Bardstown');
      break;
    case '104':
      parts.push('Available In KYGUNCO Louisville');
      break;
    default:
      break;
  }

  return parts.join(' ');
});
</script>
